import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';


const ColorCircularProgress = withStyles({
    root: {
      color: '#4daf50',
    },
  })(CircularProgress);

  const useStyles = theme => ({
    root: {
      flexGrow: 1,
      justifyContent: "center", 
      display: "flex"
    }
  });


class Circular extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { classes, ...props } = this.props;

        return (
            <div className={classes.root}>
                <ColorCircularProgress size={60} thickness={4} {...props}/>
            </div>
        );
    }
}
export default withStyles(useStyles)(Circular);